import React, { useState, useMemo } from 'react';
import MaterialTable from 'material-table';
import { withStyles, Fab, Tooltip, IconButton, Typography } from '@material-ui/core';
import { Add, CloudDownload, CloudUpload, Refresh } from '@material-ui/icons';
import * as actions from './store/permissionActions';
import * as action from '../../np-core/Auth/store/authActions';
import { isSuperUser } from '../../sc-utilities';
import { connect } from 'react-redux';
import PermissionDelete from './PermissionDelete'
import { hasPermission, BackButton, localization, getDimensionsOfPagination } from '../../sc-utilities';
import { CsvBuilder } from 'filefy';
import { MuiTableRows } from '../../../themes';

const styles = theme => ({
    "@global": {
        "[class*='buttonsCustomer']": {
            margin: theme.spacing(),
            fontSize: '13px',
            width: '100%',
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
                color: theme.palette.buttonText.default
            },
        },
        "[class*='paletteButtons']": {
            backgroundColor: theme.palette.primary.main,
            color: theme.palette.buttonText.default,
            margin: theme.spacing(),
            '&:hover': {
                backgroundColor: theme.palette.secondary.main,
            },
        },
        "[class*='MuiTableCell-root MuiTableCell-body']": {
            height: "40px",
            padding: '2px',
            fontSize: '0.7rem'
        },
    },
    fab: {
        textTransform: "none",
        width: '50%',
        color: theme.palette.buttonText.default,
        marginLeft: theme.spacing(),
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        }
    },
    customToolbar: {
        marginLeft: 14,
        paddingTop: '4px',
        width: "900px"
    },
    tableTitle: {
        display: 'flex',
        paddingTop: '4px',
        flexDirection: 'row',
        alignItems: 'center',
        overflow: 'visible',
    },
    customTooltip: {
        marginLeft: -16,
        marginTop: '-2px'
    }
});
let pageSize = 100;
let rowsPageSizeInit = [20, 50, 100];

const PermissionsList = props => {
    const { classes, permissions, translations, deleteModalState, goToUploadPermissions, saveColumnsFilter, activeCustomer, tableColumns, permission, fetchPermissions, tableActions, fetchPermissionsCount, tableRef, handleDownload } = props;

    const customExport = (columns, permissionList) => {
        if (columns && columns[0].field === 'Action') {
            columns.shift()
        }
        const data = permissionList.map(permission => {
            let returnObj = [
                permission.Name ? permission.Name : translations['short_not_assigned'] || 'n/a',
                permission.Key ? permission.Key : translations['short_not_assigned'] || 'n/a',
                permission.Module ? permission.Module : translations['short_not_assigned'] || 'n/a',
                permission.Locked ? translations['yes'] || 'Yes' : translations['no'] || 'No',
                permission.Type ? permission.Type : translations['short_not_assigned'] || 'n/a'
            ];
            return returnObj;
        });
        const builder = new CsvBuilder(`securaze_warehouse_${Math.floor(Date.now() / 1000)}.csv`);
        builder
            .setDelimeter('|')
            .setColumns(columns.map(columnDef => columnDef.title))
            .addRows(data)
            .exportFile();
    };

    const fetching = permission.fetching;
    const columnObject = useMemo(() => tableColumns
        // eslint-disable-next-line react-hooks/exhaustive-deps
        , []); const [tableOptions, setTableOptions] = useState({
            filtering: true,
            sorting: false,
            exportFileName: 'permission',
            filterCellStyle: { maxWidth: '200px' },
            search: false,
            exportCsv: customExport,
            minBodyHeight: window.innerHeight - 238 < 300 ? 300 : window.innerHeight - 238,
            maxBodyHeight: window.innerHeight - 238,
            pageSizeOptions: rowsPageSizeInit,
            exportButton: false,
            rowStyle: (_rowData, index) => {
                return { backgroundColor: index % 2 ? MuiTableRows.odd : MuiTableRows.even };
            },
            columnsButton: true,
            pageSize: pageSize ? pageSize : 50,
            emptyRowsWhenPaging: false
        });

    const filterQuery = filters => {
        let obj = {};
        for (var filter of filters) {
            obj[filter.column.field] = filter.value;
        }
        return obj;
    }

    async function fetchTableData(query) {
        let q = filterQuery(query.filters);

        query['ActiveCustomerID'] = activeCustomer;
        query['q'] = q;
        let count = await fetchPermissionsCount(query);
        if (!query['page'] && query['pageSize'] !== 20 && query['pageSize'] !== 100) {
            let dimensions = getDimensionsOfPagination(count)
            query['pageSize'] = dimensions.pageSize
            rowsPageSizeInit = dimensions.rowsPageSize
            pageSize = dimensions.pageSize

        }
        let result = await fetchPermissions(query);
        setTableOptions({ ...tableOptions, pageSize: query['pageSize'], pageSizeOptions: rowsPageSizeInit });
        return { data: result, page: query.page, pageSize: pageSize, totalCount: count };

    }

    const columnHidden = newColumnState => {
        let objToSendColumn = {}
        let objColumns = {}
        columnObject.map(column => {
            objColumns[`${column.field}`] = column.hidden
            return objColumns
        })
        objToSendColumn[`UserActivity`] = objColumns
        saveColumnsFilter({ ...objToSendColumn, ActiveCustomerID: activeCustomer })
        return newColumnState
    }

    const tableTitle = () => {
        return <div className={classes.customToolbar}>  <div className={classes.tableTitle}>
            {BackButton(translations, classes.customTooltip)}
            <Typography> {translations["permissions"] || "Permissions"}</Typography>
            {hasPermission(permissions, "permission_create") ? (
                <Fab
                    variant="extended"
                    size="small"
                    color="primary"
                    aria-label="Add"
                    style={{ borderRadius: '1px' }}
                    className={classes.fab}
                    onClick={props.goToCreatePermissions}
                >
                    <Add size="small" />
                    {translations["create_new"] || "Create new"}
                </Fab>) : null}
            <Tooltip title={translations["refresh"] || "Refresh"}>
                <IconButton aria-label={translations["refresh"] || "Refresh"} component="div" disabled={fetching} onClick={() => tableRef.current && tableRef.current.onQueryChange()}>
                    <Refresh />
                </IconButton>
            </Tooltip>
        </div>
            <>
                {hasPermission(permissions, "import_permissions") ? (

                    <Tooltip title={translations["import_permission"] || "Import permission"}>
                        <IconButton aria-label={translations["import_permission"] || "Import permission"} value='csv'
                            onClick={() => goToUploadPermissions()}>
                            <CloudUpload />
                        </IconButton>
                    </Tooltip>
                ) : null}
                {hasPermission(permissions, "export_permissions") ? (

                    <Tooltip title={translations["export_permission"] || "Export permission"}>
                        <IconButton aria-label={translations["export_permission"] || "Export permission"} value='csv' onClick={handleDownload}>
                            < CloudDownload />
                        </IconButton>
                    </Tooltip>
                ) : null}
            </>
        </div>
    }
    const handleCloseDanger = async () => {
        if (deleteModalState.open) {
            await props.deletePermission({ PermissionID: deleteModalState.permissionID, ActiveCustomerID: activeCustomer });
            props.handleDelete();
            tableRef.current && tableRef.current.onQueryChange()
        }
    }

    const handleChangePage = () => {
        tableRef.current && (tableRef.current.tableContainerDiv.current.scrollTop = 0);
    }

    return (<><MaterialTable
        tableRef={tableRef}
        title={tableTitle()}
        columns={columnObject}
        data={fetchTableData}
        options={tableOptions}
        onChangeRowsPerPage={(size) => {
            setTableOptions({ ...tableOptions, pageSize: size })
            pageSize = size
        }}
        isLoading={fetching}
        localization={localization(translations)}
        onChangeColumnHidden={columnHidden}
        actions={isSuperUser() ? tableActions : null}
        onChangePage={() => {if(tableRef?.current?.tableContainerDiv?.current) {tableRef.current.tableContainerDiv.current.scrollTop = 0}}}
    />
        {hasPermission(permissions, "permission_delete") ? (
            <PermissionDelete
                activeCustomer={activeCustomer}
                deleteModalState={deleteModalState}
                entityName={"Permission"}
                translations={translations}
                handleDelete={props.handleDelete}
                handleCloseDanger={handleCloseDanger}
            />
        ) : null}
    </>)
}

const mapDispatchToProps = dispatch => {
    return {
        fetchPermissionsCount: filterParams => dispatch(actions.fetchPermissionsCount(filterParams)),
        fetchPermissions: filterParams => dispatch(actions.fetchPermissions(filterParams)),
        saveColumnsFilter: data => dispatch(action.saveColumnsFilter(data)),
        deletePermission: filterParams => dispatch(actions.deletePermissions(filterParams))
    };
};

const mapStateToProps = state => {
    return {
        activeCustomer: state?.core?.login?.activeCustomer?.CustomerID ?? null,
        permissions: state?.core?.login?.permissions || [],
        permission: state.admin.permission,
        translations: state.translate && state.translate.translations ? state.translate.translations.activeTranslations || {} : {}
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withStyles(styles, { withTheme: true })(PermissionsList));